import { styled, Switch } from "@mui/material";

import theme from "../lib/theme";

export const CustomSwitch = styled(Switch)({
  switchBase: {
    color: "#fff",
    "&$checked": {
      color: theme.palette.success.main,
    },
    "&$checked + $track": {
      backgroundColor: theme.palette.success.main,
    },
  },
  checked: {},
  track: {
    backgroundColor: "#aaa",
  },
});
